import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { ReactTable } from '../../../components/shared';
import { MONTHLY_RECONCILIATION_SUBLOCATION_TABLE } from '../../../constants/tableColumns';

const SubLocationVariancePanel = ({ data = [] }) => {
  const columns = useMemo(() => MONTHLY_RECONCILIATION_SUBLOCATION_TABLE(), []);
  return (
    <Box sx={{ mt: 2, backgroundColor: '#FAFAFA', p: 3, borderRadius: 1 }}>
      {/* Sub-location Table */}
      <ReactTable
        columns={columns}
        data={data}
        pagination={false}
        disablePagination={true}
        getRowProps={(row) => {
          if (row.original && row.original.isSummaryRow) {
            return {
              style: {
                backgroundColor: '#F9FAFB',
                fontWeight: 800,
                borderTop: '2px solid #E0E0E0',
              },
            };
          }
          return {};
        }}
      />
    </Box>
  );
};

export default SubLocationVariancePanel;
